import React from "react";

const MAX_ROW_ERRORS = 10;

const ui_utils = {
  colorGrey: { color: "#707275" },
  removeLineBreak: (str) => {
    return str.replace("<br/>", "");
  },
  removeAsteriskAndConditionalSymbols: (str) => {
    let newStr = str.replace(".§", "");
    newStr = newStr.replace(".*", "");
    newStr = newStr.replace("§", "");
    return newStr.replace("*", "");
  },
  capitalizeAllFirstChars: (sentence) => {
    if (!!sentence) {
      const words = sentence.split(" ");
      const capitalizedWords = words.map((word) => {
        if (!!word[0]) {
          return word[0].toUpperCase() + word.substr(1);
        }
      });
      return capitalizedWords.join(" ");
    }
  },
  isOrAre: (count) => {
    return count !== 1 ? "are" : "is";
  },
  pluralS: (count, str) => {
    return count > 1 ? str + "s" : str;
  },
  renderErrorMessage: (code, message) => {
    return Array.isArray(message) ? (
      message
        .map((msg, row) => {
          if (msg) {
            msg =
              typeof msg === "string"
                ? msg
                : `Please resolve errors on row ${row + 1}`;
            return <li key={`${row}_${code}`}>{`Field ${code}: ${msg}`}</li>;
          }
        })
        .filter((message) => message)
    ) : (
      <ul>
        <li key={`${code}`}>{`Field ${
          code ?? "error(s) exits on this page"
        }: ${message}`}</li>
      </ul>
    );
  },
};

export default ui_utils;
